import axios from "axios";
import { useCallback, useEffect, useState } from "react";

import { cabecalhosDoCliente } from "@/features/cliente-sessao";

/**
 * O cartão do cliente logado no cardápio (ou no Totem/Mesa QR). `canal` é o
 * módulo da tela ("Cardapio", "Totem", "MesaQR"): fora dos canais marcados
 * pela loja, o cartão não aparece; `canal = null` (ficha do cliente no painel)
 * mostra sempre. Ler o cartão pela rota pública abre o cartão do cliente (2/10)
 * se a loja está com ele ligado — é o "Meu cartão". A rota pública exige a
 * pulseira do cliente (01/11/2026) — ou o login da loja, no Totem.
 */
export default function useCartaoFidelidade(clienteId, canal = "Cardapio", { autenticado = false } = {}) {
  const [estado, setEstado] = useState(null);

  const recarregar = useCallback(async () => {
    if (!clienteId) { setEstado(null); return null; }
    try {
      const url = autenticado ? `/api/fidelidade/cliente/${clienteId}` : `/api/public/fidelidade/cartao/${clienteId}`;
      const headers = autenticado ? { Authorization: `Bearer ${localStorage.getItem("token")}` } : cabecalhosDoCliente();
      const { data } = await axios.get(url, { headers });
      const vale = data?.ativo && (!canal || (data.canais || []).includes(canal));
      setEstado(vale ? data : null);
      return vale ? data : null;
    } catch {
      setEstado(null);
      return null;
    }
  }, [clienteId, canal, autenticado]);

  useEffect(() => { recarregar(); }, [recarregar]);
  return { estado, premios: estado?.premios || [], recarregar };
}
